import { Directive, HostListener, Renderer2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { IsDarkTheme } from '@riise/shared/directives/is-dark-theme.directive';

@Directive({
  selector: '[appToggleTheme]'
})
export class ToggleThemeDirective {
  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);
  private isDarkThemeService = inject(IsDarkTheme);

  /** Inserted by Angular inject() migration for backwards compatibility */


  constructor() {}

  @HostListener('click') toggleTheme() {
    const body = this.document.body;
    if (body) {
      if (body.classList.contains('dark-mode')) {
        this.renderer.removeClass(body, 'dark-mode');
      } else {
        this.renderer.addClass(body, 'dark-mode');
      }
      this.renderer.removeClass(body, 'bg-img1');
      this.renderer.removeClass(body, 'bg-img2');
      this.renderer.removeClass(body, 'bg-img3');
      this.renderer.removeClass(body, 'bg-img4');

      let newValue = !this.isDarkThemeService.getBoolValue();
      this.isDarkThemeService.setBooleanValue(newValue);
    }
  }
}
